import { render } from "./UseItemScroll.vue?vue&type=template&id=24af0e5e"
import script from "./UseItemScroll.vue?vue&type=script&lang=js"
export * from "./UseItemScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UseItemScroll.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24af0e5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24af0e5e', __exports__)) {
    api.reload('24af0e5e', __exports__)
  }
  
  module.hot.accept("./UseItemScroll.vue?vue&type=template&id=24af0e5e", () => {
    api.rerender('24af0e5e', render)
  })

}


export default __exports__